import React from "react";
import styles from "./NewUser.module.sass";

import Alert from "../../components/Alert/Alert";
import PurchaseDetailsCard from "../../components/PurchaseDetailsCard/PurchaseDetailsCard";
import UserForm from "../../components/UserForms/UserForm";
import currency from "../../utils/currency";
import api from "../../utils/api";
import masks from "../../utils/masks";
import dateUtils from "../../utils/date";
import AppContext from "../../contexts/appContext";

const PAYMENT_URL = "/pagamento";

class NewUser extends React.Component {
  constructor(props) {
    super(props);
    this.consentDataRef = React.createRef(null);
  }

  submitHandler = (userData) => {
    this.validate(userData);
  };

  static contextType = AppContext;

  validateLgpdConsent = () => {
    let isValid = true;
    const consentData = this.consentDataRef.current.validate();
    if (consentData.invalid) {
      isValid = false;
    }
    return isValid;
  };

  getAllInputs = () => {
    const form = document.getElementById("userForm");
    const inputs = Array.from(form.getElementsByTagName("input")).filter(
      (input) => !input.readOnly
    );

    for (const input of Array.from(inputs)) {
      input.focus();
      input.blur();
    }

    return inputs;
  };

  validate = (userData) => {
    let validForm = true;
    let divToFocus;

    const inputs = this.getAllInputs();

    const verifyPartner = () =>
      userData.newPartner != null && userData.additionalInfo != null;

    setTimeout(() => {
      validForm = this.validateLgpdConsent();

      for (const input of Array.from(inputs)) {
        if (input.getAttribute("valid") === "false") {
          validForm = false;
          divToFocus = divToFocus || input;
        }
      }

      if (validForm) {
        if (verifyPartner()) {
          userData.additionalInfo.push(userData.newPartner);
        }
        this.submit(userData);
      } else {
        if (divToFocus) {
          divToFocus.click();
          divToFocus.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    }, 0);
  };

  submit = (userData) => {
    const requestBody =
      this.context.selectedIdentifier === "cpf"
        ? this.getPFRequestBody(userData)
        : this.getPJRequestBody(userData);

    const cotationRequestBody = {
      tipo: {
        descricao: this.context.product.id === "1" ? "IMÓVEIS" : "MÓVEIS",
        codigo: this.context.product.codigo,
      },
      grupo: {
        codigo: this.context.selectedOffer.identificacao.codigo,
        codigoBem: this.context.selectedOffer.codigoBem,
        codigoProduto: this.context.selectedOffer.codigoProduto,
        codigoPlanoVenda: this.context.selectedOffer.dados.plano.identificacao
          .codigo,
        codigoVenda: this.context.selectedOffer.identificacao.codigoVenda,
        codigoSubProduto: this.context.product.id,
        codigoTaxaPlano: this.context.selectedOffer.dados.plano.identificacao
          .codigoTaxa,
        prazo: this.context.selectedOffer.dados.plano.prazo.total,
      },
      cliente: {
        pessoa: {
          identificacao: {
            codigo: this.context.document,
          },
        },
      },
    };

    const saveClientEndpoint = api.endpoints.SAVE_CLIENT;
    api.post(saveClientEndpoint, { pessoa: requestBody }).then(() => {
      this.postSaveCotation(cotationRequestBody, requestBody);
    });
  };

  postSaveCotation = (cotationRequestBody, requestBody) => {
    const saveCotationEndpoint = api.endpoints.SAVE_COTATION;
    api.post(saveCotationEndpoint, cotationRequestBody).then(({ data }) => {
      this.context.setContext({
        ...this.context,
        client: {
          ...this.context.client,
          pessoa: requestBody,
        },
        insurance: false,
        cotationCode: data[0].identificacao.codigo,
        cotationBusinessCode: data[0].identificacao.codigoNegocio,
      });
      this.getAgeValidation();
    });
  };

  getAgeValidation = () => {
    const ageValidationEndpoint = api.endpoints.AGE_VALIDATION;
    if (this.context.selectedIdentifier === "cpf") {
      api
        .get(ageValidationEndpoint, null, {
          cpf: this.context.document,
        })
        .then((result) => {
          this.context.setContext({
            ...this.context,
            allowInsurance: result.data.valida && !this.context.ibc,
          });

          this.props.history.push({
            pathname:
              result.data.valida && !this.context.ibc ? "/seguro" : PAYMENT_URL,
          });
        });
    } else {
      this.props.history.push({
        pathname: PAYMENT_URL,
      });
    }
  };

  render() {
    return (
      <div className={styles.content}>
        <div className={styles.dataContent}>
          <div className={styles.alert}>
            <Alert
              title="Fique atento!"
              text="Estes dados são importantes e irão para o seu contrato. Preencha-os corretamente."
            />
            <UserForm
              consentDataRef={this.consentDataRef}
              clientData={this.context.client}
              onSubmit={this.submitHandler}
              data={this.context}
              history={this.props.history}
            />
          </div>
        </div>

        <div className={styles.card}>
          <PurchaseDetailsCard offer={this.context} />
        </div>
      </div>
    );
  }

  getPJRequestBody(userData) {
    const partners = [];
    userData.additionalInfo.forEach((partner) => {
      partners.push(
        partner.cotista
          ? {
              codigo: partner.codigo,
              participacao: partner.participation,
            }
          : {
              identificacao: {
                tipo: "Fisica",
                documento: "CPF",
                codigo: partner.cpf,
              },
              nome: partner.name,
              participacao: partner.participation,
              dataNascimento: dateUtils.format2Service(
                masks.date(partner.birthDate)
              ),
              sexo: {
                codigo: partner.gender,
              },
            }
      );
    });

    const pessoa = {
      identificacao: {
        tipo: "Juridica",
        documento: "CNPJ",
        codigo: this.context.document,
      },
      dadosPessoaJuridica: {
        nomeFantasia: userData.user.socialName,
        dataFundacao: dateUtils.format2Service(
          masks.date(userData.user.foundationDate)
        ),
        documento: {
          documento: "IE",
          codigo: userData.user.document,
          orgaoEmissor: userData.user.emitter,
        },
        informacoesEconomicas: {
          valorCapital: currency.currencyToNumber(
            userData.user.capitalSocialValue
          ),
          valorFaturamento: currency.currencyToNumber(
            userData.user.anualRevenues.replace("R$ ", "")
          ),
        },
        qualificadores: [
          {
            codigo: "PEP",
            valor: userData.exposed,
          },
        ],
        atividade: {
          codigo: userData.user.activityType,
        },
        naturezaJuridica: {
          codigo: userData.user.legalNature,
        },
        socios: partners,
      },
      nome: userData.user.socialName,
      endereco: {
        cep: userData.address.cep,
        pais: userData.address.country,
        estado: userData.address.uf,
        cidade: userData.address.city,
        bairro: userData.address.district,
        logradouro: userData.address.street,
        complemento: userData.address.complement,
        numero: userData.address.number,
      },
      comunicacao: {
        email: userData.user.email,
        telefones: [
          {
            cidade: userData.user.cellPhoneDetails.city,
            UF: userData.user.cellPhoneDetails.uf,
            ddd: userData.user.cellPhoneDetails.ddd,
            numero: userData.user.cellPhoneDetails.number,
            tipo: "celular",
          },
        ],
      },
    };

    if (userData.user.phoneNumberDetails) {
      pessoa.comunicacao.telefones.push({
        cidade: userData.user.phoneNumberDetails.city,
        UF: userData.user.phoneNumberDetails.uf,
        ddd: userData.user.phoneNumberDetails.ddd,
        numero: userData.user.phoneNumberDetails.number,
        tipo: "telefone",
      });
    }
    this.context.setContext({
      ...this.context,
      copyPerson: pessoa,
    });
    return pessoa;
  }

  getPFRequestBody(userData) {
    const pessoa = {
      identificacao: {
        tipo: "Fisica",
        documento: "CPF",
        codigo: this.context.document,
      },
      nome: userData.user.nome,
      dadosPessoaFisica: {
        dataNascimento: dateUtils.format2Service(
          masks.date(userData.user.nascimento)
        ),
        documento: {
          tipo: "2",
          documento: "RG",
          codigo: userData.user.documento,
          orgaoEmissor: userData.user.emissor,
        },
        acessibilidade: {
          codigo: userData.user.acessibilidade,
        },
        sexo: {
          codigo: userData.user.sexo,
        },
        estadoCivil: {
          codigo: userData.user.estadocivil,
        },
        profissao: {
          codigo: userData.user.profissao,
        },
        nacionalidade: {
          codigo: userData.user.nacionalidade,
        },
        naturalidade: {
          codigo: userData.user.estado,
          valor: userData.user.naturalidade,
        },
        filiacao: {
          mae: userData.user.mae,
          pai: userData.user.mae,
        },
        informacoesEconomicas: {
          faixaRenda: [
            {
              valor: currency.currencyToNumber(
                userData.user.renda.replace("R$ ", "")
              ),
            },
          ],
        },
        qualificadores: [
          {
            codigo: "PEP",
            valor: userData.user.exposed,
          },
        ],
      },
      endereco: {
        cep: userData.address.cep,
        pais: userData.address.country,
        estado: userData.address.uf,
        cidade: userData.address.city,
        bairro: userData.address.district,
        logradouro: userData.address.street,
        complemento: userData.address.complement,
        numero: userData.address.number,
        qualificador: {
          valor: "R",
        },
      },
      comunicacao: {
        email: userData.user.email,
        telefones: [
          {
            cidade: userData.user.celularDetails.city,
            UF: userData.user.celularDetails.uf,
            ddd: userData.user.celularDetails.ddd,
            numero: userData.user.celularDetails.number,
            tipo: "celular",
          },
        ],
      },
    };

    if (userData.user.fixoDetails) {
      pessoa.comunicacao.telefones.push({
        cidade: userData.user.fixoDetails.city,
        UF: userData.user.fixoDetails.uf,
        ddd: userData.user.fixoDetails.ddd,
        numero: userData.user.fixoDetails.number,
        tipo: "telefone",
      });
    }

    if (userData.user.fatca.fatca === "S") {
      pessoa.dadosPessoaFisica.fatca = {
        paisNascimento: userData.user.fatca.paisNascimento,
        paisResidenciaFiscal: userData.user.fatca.paisResidenciaFiscal,
      };

      if (userData.user.fatca.flagPaisObrigacao === "S") {
        pessoa.dadosPessoaFisica.fatca.paisObrigacaoFiscal =
          userData.user.fatca.paisObrigacaoFiscal;
        pessoa.dadosPessoaFisica.fatca.nif = userData.user.fatca.nif;
      }
    }

    if (userData.user.conjuge.cpf.length > 0) {
      pessoa.dadosPessoaFisica.conjuge = userData.user.conjuge.cotista
        ? {
            codigo: userData.user.conjuge.codigo,
          }
        : {
            nome: userData.user.conjuge.nome,
            identificacao: {
              tipo: "Fisica",
              documento: "CPF",
              codigo: userData.user.conjuge.cpf,
            },
            dataNascimento: dateUtils.format2Service(
              masks.date(userData.user.conjuge.nascimento)
            ),
            documento: {
              tipo: "2",
              documento: "RG",
              codigo: userData.user.conjuge.documento,
              orgaoEmissor: userData.user.conjuge.emissor,
            },
            acessibilidade: {
              codigo: userData.user.conjuge.acessibilidade,
            },
            sexo: {
              codigo: userData.user.conjuge.sexo,
            },
            naturalidade: {
              codigo: userData.user.conjuge.estado,
              valor: userData.user.conjuge.naturalidade,
            },
            informacoesEconomicas: {
              faixaRenda: [
                {
                  valor: currency.currencyToNumber(
                    userData.user.conjuge.renda.replace("R$ ", "")
                  ),
                },
              ],
            },
          };
    }
    this.context.setContext({
      ...this.context,
      copyPerson: pessoa,
    });
    return pessoa;
  }
}

export default NewUser;
